import { createGlobalStyle } from 'styled-components';
import { Images, Colors } from '../themes';

const BackgroundWithMap = `
  background-image:
  url('${Images.inStationMap}'),
  url("${Images.tiles.footerLeft}"),
  url("${Images.tiles.footerRight}"),
  url("${Images.background}");
  background-repeat: no-repeat;
  background-position:  right top, bottom left, bottom right,center;
  background-size: 50%, 15%, 30%, auto;
  background-attachment: fixed, scroll, scroll,fixed;
`;

const BackgroundWithoutMap = `
  background-image: 
  url("${Images.tiles.footerLeft}"),
  url("${Images.tiles.footerRight}"),
  url("${Images.background}");
  background-repeat: no-repeat;
  background-position: bottom left, bottom right, top;
  background-size: 15%, 30%, 100%;
  background-attachment: scroll, scroll, fixed;

  @media(max-width: 960px){
    background-size: 0, 0, auto;
  }
`;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  button{
    cursor: pointer;
  }

  button, input{
    outline: 0;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  body {
    ${props => (props.showMapImage ? BackgroundWithMap : BackgroundWithoutMap)}
    background-color: #000000;
    font-family: 'Roboto', sans-serif;
    min-height: 100vh;
  }

  @-webkit-keyframes autofill {
    0%,
    100% {
      color: ${Colors.text.main};
      background: transparent;
    }
  }

  input:-webkit-autofill {
    -webkit-animation-delay: 1s; /* Safari support - any positive time runs instantly */
    -webkit-animation-name: autofill;
    -webkit-animation-fill-mode: both;
  }
`;
